(function () {
    if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
    window.scrollTo(0, 0);

    var key = 'sp:' + location.pathname + location.search;
    var saved = sessionStorage.getItem(key);

    if (saved) {
        document.addEventListener('DOMContentLoaded', function () {
            requestAnimationFrame(function () { window.scrollTo(0, +saved); });
        });
    }

    window.addEventListener('pagehide', function () {
        sessionStorage.setItem(key, window.scrollY);
    });

    window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            var v = sessionStorage.getItem(key);
            window.scrollTo(0, v ? +v : 0);
        }
    });
})();
